// A small SMS compose that opens under a queue row. The text starts from the
// Templates configurator (@aiw/config) with {{name}}, {{suburb}}, {{ref}}
// filled in; the person edits and sends. Sending is a proposal (add_touch,
// channel sms) — the chip says what that reaches.
import { useState } from "react";
import { Button, KindChip, Textarea, caseKind } from "@aiw/ui";
import { Templates } from "@aiw/config";

export function fillTemplate(key: string, vars: { name: string; suburb: string; ref: string }): string {
  const t = Templates.defaults.templates[key] ?? Templates.defaults.templates.first_reply!;
  return t.body.replace(/\{\{name\}\}/g, vars.name).replace(/\{\{suburb\}\}/g, vars.suburb).replace(/\{\{ref\}\}/g, vars.ref);
}

export function FollowUpCompose({ to, templateKey, vars, busy, onSend, onClose }: {
  to: string;
  templateKey: string;
  vars: { name: string; suburb: string; ref: string };
  busy?: boolean;
  onSend: (text: string) => void | Promise<void>;
  onClose: () => void;
}) {
  const [text, setText] = useState(() => fillTemplate(templateKey, vars));
  const label = templateKey.replace(/_/g, " ");
  return (
    <div className="rounded-md border bg-background p-3 text-sm">
      <div className="mb-1.5 flex flex-wrap items-center gap-2 text-micro text-muted-foreground">
        <span>SMS to <span className="font-medium text-foreground">{to}</span></span>
        <span>· template “{label}”</span>
        <span className="ml-auto"><KindChip kind={caseKind({ command: "add_touch", radius: 1 })} /></span>
      </div>
      <Textarea value={text} onChange={(e) => setText(e.target.value)} rows={3} maxLength={320} aria-label="SMS text" />
      <div className="mt-2 flex items-center gap-2">
        <Button size="sm" disabled={busy || text.trim().length < 3} onClick={() => void onSend(text.trim())}>Send SMS</Button>
        <Button size="sm" variant="ghost" onClick={onClose}>Cancel</Button>
        <span className="num ml-auto text-micro text-muted-foreground">{text.length} / 320</span>
      </div>
    </div>
  );
}
